import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import { RouterLink } from 'src/routes/components';
import { paths } from 'src/routes/paths';

type Props = {
  name?: string;
  serviceLineId?: string;
  clientId?: string;
  fallback: string;
  'data-test-id'?: string;
};

export function ServiceLineNameLink({
  name,
  serviceLineId,
  clientId,
  fallback,
  'data-test-id': testId,
}: Props) {
  if (!name) {
    return (
      <Typography variant="body2" data-test-id={testId}>
        {fallback}
      </Typography>
    );
  }

  if (!serviceLineId || !clientId) {
    return (
      <Typography variant="body2" data-test-id={testId}>
        {name}
      </Typography>
    );
  }

  return (
    <Link
      component={RouterLink}
      href={paths.dashboard.serviceLineOverview(serviceLineId, clientId)}
      variant="body2"
      data-test-id={testId}
      onClick={(e) => e.stopPropagation()}
      color="text.primary"
      sx={{
        textDecoration: 'underline',
        '&:hover': { color: 'text.primary' },
      }}
    >
      {name}
    </Link>
  );
}
